<div class="_bar-wrapper bg-col-w"
     [elementHeight]="'pwa-bottom-bar'">
    <button [routerLink]="'/'"
            [class._active]="isCurrentPage(EPwaMenuActiveState.home)"
            class="_itemLink _home">
        <i class="icon-app-home _icon"
           appUserNotificationsQtyBullet></i>
        <p class="m-t-1 p3">{{'Home' | translate}}</p>
    </button>
    <button [class._active]="isCurrentPage(EPwaMenuActiveState.shop)"
            class="_itemLink"
            (click)="openOffCanvas()">
        <i class="icon-app-search _icon"></i>
        <p class="m-t-1 p3">{{'Shop' | translate}}</p>
    </button>
    @if(canShowCommunity){
    <button (click)="openCommunity()"
            [class._active]="isCurrentPage(EPwaMenuActiveState.community)"
            class="_itemLink">
        <i class="_icon"
           [ngClass]="communityStatus.busy ? 'icon-loading' : 'icon-app-community'"></i>
        <p class="m-t-1 p3">{{'Community' | translate}}</p>
    </button>
    }

    <button [routerLink]="'/account'"
            [class._active]="isCurrentPage(EPwaMenuActiveState.account)"
            class="_itemLink">
        <i class="icon-app-account _icon"></i>
        <p class="m-t-1 p3">{{'Account' | translate}}</p>
    </button>
    <button [routerLink]="'/basket'"
            [class._active]="isCurrentPage(EPwaMenuActiveState.basket)"
            class="_itemLink">
        <basket-qty class="inline-flex _basket-qty"
                    [icon]="'icon-app-basket'"></basket-qty>
        <p class="m-t-1 p3">{{'Basket' | translate}}</p>
    </button>
</div>
